module.exports = __webpack_public_path__ + "img/ccl_gallery5.4828be68.jpg";